import { render, staticRenderFns } from "./DialogDetailantrag.vue?vue&type=template&id=09ae23cd&scoped=true"
import script from "./DialogDetailantrag.vue?vue&type=script&lang=ts"
export * from "./DialogDetailantrag.vue?vue&type=script&lang=ts"
import style0 from "./DialogDetailantrag.vue?vue&type=style&index=0&id=09ae23cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ae23cd",
  null
  
)

export default component.exports